import React from 'react';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="min-h-screen bg-brand-cream selection:bg-brand-mint" data-id="element-0" data-mp="3iiwfuqnezm4a">
      <main data-id="element-1" data-mp="3ml1419v3fqjj">
        <HeroSection data-id="element-2" data-mp="3mkrcviybbdc9" />
        <StatsBar data-id="element-3" data-mp="3mjzsl4a6121a" />
        <TransformationSection data-id="element-4" data-mp="3mjgannkimdn9" />
        <PainPointsSection data-id="element-5" data-mp="3rcj8i7wbs999" />
        <KitContentsSection data-id="element-6" data-mp="3rdar8i4tqci4" />
        <InstantAccessSection data-id="element-7" data-mp="3rd18nfm3z7mg" />
        <BonusesSection data-id="element-8" data-mp="5osn3wyp084" />
        <PricingSection data-id="element-9" data-mp="680frswe88f" />
        <GuaranteeSection data-id="element-10" data-mp="5ggje8nxyxz" />
        <TestimonialsSection data-id="element-11" data-mp="7svdij4jt6t" />
        <AboutSection data-id="element-12" data-mp="2zllduyaeeel5" />
        <FAQSection data-id="element-13" data-mp="2zmepodo7rua5" />
        <FinalCTASection data-id="element-14" data-mp="2zmwit1fkxsdu" />
      </main>
      <Footer data-id="element-15" data-mp="33mf2jtvnzxf3" />
      <SocialProofPopup data-id="element-16" data-mp="33lwxq8uxsavk" />
      <StickyCTA data-id="element-17" data-mp="33ngfy505kvzz" />
    </div>;
}